import { InjectionToken } from '@angular/core';
import { adminUserDtos } from '@vectronic/openApi-admin';
import { Observable } from 'rxjs';
export interface IDatatableColumnStorageService {
  get(tableId: string): Observable<adminUserDtos.DatatableSettings>;

  set(tableId: string, data: adminUserDtos.DatatableSettings): Observable<void>;
}

export const DatatableColumnStorageService = new InjectionToken<IDatatableColumnStorageService>(
  'DatatableColumnStorageService',
);
